import axios from 'axios'
import { apiConfig, storageKeys } from '@config'
import useAuthStore from '@store/authStore'

// Instance Axios principale
const apiClient = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: apiConfig.timeout,
  headers: apiConfig.headers,
})

// Intercepteur de requête - Ajout du token d'authentification
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem(storageKeys.authToken)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Intercepteur de réponse - Gestion des erreurs
apiClient.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response) {
      // Erreur de réponse du serveur
      switch (error.response.status) {
        case 401:
          // Effacer l'état d'auth — PrivateRoute gère la redirection via React Router
          localStorage.removeItem(storageKeys.authToken)
          localStorage.removeItem(storageKeys.refreshToken)
          useAuthStore.setState({ user: null, token: null, userType: null, isAuthenticated: false })
          break
        case 403:
          console.error('Accès interdit')
          break
        case 404:
          console.error('Ressource introuvable')
          break
        case 500:
          console.error('Erreur serveur')
          break
        default:
          console.error('Erreur:', error.response.data)
      }
    } else if (error.request) {
      // Erreur de requête
      console.error('Erreur de connexion')
    } else {
      console.error('Erreur:', error.message)
    }
    return Promise.reject(error)
  }
)

export default apiClient
